import script from "./ElementMessage.vue?vue&type=script&lang=js"
export * from "./ElementMessage.vue?vue&type=script&lang=js"

import "./ElementMessage.vue?vue&type=style&index=0&id=3d280162&lang=scss"

const __exports__ = script;

export default __exports__